import React from "react";
import { Link } from "react-router-dom";
import { formatINR } from "../../lib/format";
import { t } from "../../lib/i18n";

export default function PackageCard({ pkg, coverImage, className = "" }) {
  const cover = pkg.hero_image_url;
  const hours = pkg.hours_of_coverage;
  const incl = (pkg.inclusions || []).length;

  return (
    <Link
      to={`/packages/${pkg.id}`}
      data-testid={`package-card-${pkg.id}`}
      className={[
        "group block overflow-hidden rounded-lg border border-[#EAE3D2] bg-white transition hover:border-[#C8A24B]",
        className,
      ].join(" ")}
    >
      <div className="relative aspect-[5/3] w-full overflow-hidden">
        {cover ? (
          <img
            src={cover}
            alt={`${pkg.name} photography sample`}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
          />
        ) : (
          <div className="h-full w-full bg-[#EAE3D2]" />
        )}
        {pkg.tier ? (
          <span className="absolute left-4 top-4 rounded-full bg-[#FAF7F2]/95 px-3 py-1 text-[10px] uppercase tracking-[0.22em] text-[#1A1A1A]">
            {pkg.tier}
          </span>
        ) : null}
      </div>
      <div className="p-5 sm:p-6">
        <h3
          data-testid={`package-card-name-${pkg.id}`}
          className="font-display text-xl text-[#1A1A1A] sm:text-2xl"
        >
          {pkg.name}
        </h3>
        {pkg.summary ? (
          <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-[#1A1A1A]/65">
            {pkg.summary}
          </p>
        ) : null}
        <div className="mt-4 flex items-end justify-between">
          <div>
            <p className="text-[10px] uppercase tracking-[0.24em] text-[#1A1A1A]/45">
              {t("packageDetail.startingAt")}
            </p>
            <p
              data-testid={`package-card-price-${pkg.id}`}
              className="font-display text-xl text-[#C8A24B] sm:text-2xl"
            >
              {formatINR(pkg.base_price_inr)}
            </p>
          </div>
          <div className="text-right text-[11px] uppercase tracking-[0.18em] text-[#1A1A1A]/50">
            {hours ? <p>{hours} hrs</p> : null}
            {incl ? <p>{incl} inclusions</p> : null}
          </div>
        </div>
      </div>
    </Link>
  );
}
